(function () {
  function initAccordion(container) {
    var triggers = container.querySelectorAll('.ask-accordion__trigger');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = this.closest('.ask-accordion__item');
        var content = item.querySelector('.ask-accordion__content');
        var isOpen = item.classList.contains('is-open');

        if (isOpen) {
          content.style.maxHeight = null;
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  var containers = document.querySelectorAll('.ask-accordion');
  containers.forEach(function (container) {
    initAccordion(container);
  });

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target;
      var accordion = section.querySelector('.ask-accordion');
      if (accordion) {
        initAccordion(accordion);
      }
    });
  }
})();
